/**
 * 統計情報関連のAPIエンドポイント
 */

import apiClient from '../client';
import type { StatisticsApiResponse } from '../../../types/api';

export interface GetStatisticsParams {
  targetDate?: string; // YYYY-MM-DD形式
  useBusinessHours?: boolean;
}

export const statisticsApi = {
  /**
   * 店舗統計情報取得
   */
  getStatistics: async (
    storeId: number,
    params?: GetStatisticsParams
  ): Promise<StatisticsApiResponse> => {
    const queryParams = new URLSearchParams();

    if (params?.targetDate) {
      queryParams.append('target_date', params.targetDate);
    }

    if (params?.useBusinessHours !== undefined) {
      queryParams.append('use_business_hours', params.useBusinessHours.toString());
    }

    const queryString = queryParams.toString();
    const url = `/statistics/${storeId}${queryString ? `?${queryString}` : ''}`;

    return apiClient.get<StatisticsApiResponse>(url);
  }
};
